<template>
  <div>
    <b-breadcrumb :items="breadcrumbItems"></b-breadcrumb>

    <h4 qid="clients-page-title">
      <router-link
          to="/administration/clients/create"
          class="btn btn-success float-right"
          qid="clients-create-button"
      >
        {{ $t('administration.clients.create_button') }}
      </router-link>
      {{ $t('administration.clients.title') }}
    </h4>

    <div class="card">
      <table class="table table-responsive-md">
        <thead>
          <tr>
            <th scope="col">{{ $t('administration.clients.create.name_label') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.processing_activities_module') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.system_module') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.contract_basic') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.contract_advanced') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.gdpr_module') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.gdpr_advanced_module') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.project_module') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.assessment_module') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.risk_module') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.advanced_reporting') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.policy_module') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.incident_module') }}</th>
            <th scope="col" class="text-center">{{ $t('administration.clients.create.ai_module') }}</th>
            <th width="150"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="object in tableItems">
            <td>
              <router-link
                  :to="{ name: 'administration.clientView', params: { slug: object.slug }}"
                  qid="clients-name"
              >
                {{object.name}}
              </router-link>
            </td>
            <td align="center">
              <span v-if="object.processingActivitiesModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.processingActivitiesModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.systemModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.systemModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.contractBasicModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.contractBasicModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.contractAdvancedModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.contractAdvancedModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.gdprModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.gdprModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.gdprAdvancedModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.gdprAdvancedModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.projectModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.projectModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.assessmentModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.assessmentModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.riskModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.riskModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.advancedReportingModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.advancedReportingModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.policyModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.policyModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.incidentModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.incidentModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td align="center">
              <span v-if="object.aiModule == true">
                <font-awesome-icon icon="check-circle" class="icon-success"/>
              </span>
              <span v-if="object.aiModule == false">
                <font-awesome-icon icon="times-circle" class="icon-danger"/>
              </span>
            </td>
            <td>
              <span class="text-muted mr-3 cursor-pointer">
                <router-link
                    :to="{ name: 'administration.clientMembers', params: { slug: object.slug }}"
                    qid="clients-members-button"
                >
                  <font-awesome-icon icon="users" />
                </router-link>
              </span>
              <span class="text-muted mr-3 cursor-pointer" qid="clients-edit-button" @click="showEditClientModal(object)">
                <font-awesome-icon icon="pen"/>
              </span>
              <span class="text-muted cursor-pointer" qid="clients-delete-button" @click="showConfirmDeleteModal(object)">
                <font-awesome-icon icon="trash-alt"/>
              </span>
            </td>
          </tr>
          <tr v-if="!loading && !tableItems.length" qid="no-results-row" class="text-center">
            <td colspan="10">
              <h5 class="mt-3">
                {{ $t('system.no_results') }}
              </h5>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mt-3 pagination row">
      <div class="col-md-6">
        <div class="row">
          <div class="float-left">
            <span class="text-muted pagination-counter">
              {{ $t('pagination.entries_per_page') }}:
            </span>
          </div>
          <div class="float-left">
            <multiselect
                v-model="perPage"
                :options="perPageOptions"
                track-by="value"
                label="value"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                qid="create-org-form-organization-level"
                @select="perPageChanged"
                :placeholder="selectedPerPage"
                @remove="perPageRemoved"
            ></multiselect>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <b-pagination
            class="float-right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="selectedPerPage"
            aria-controls="my-table"
            @change="pageChanged"
            limit="1"
        >
          <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
          <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
          <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
          <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
          <div slot="ellipsis-text">
            <b-spinner small type="grow"></b-spinner>
            <b-spinner small type="grow"></b-spinner>
            <b-spinner small type="grow"></b-spinner>
          </div>
          <span class="text-muted" slot="page" slot-scope="{ page, active }">
            <span v-if="active">{{getPerPage}}</span>
          </span>
        </b-pagination>
      </div>
    </div>


    <!-- Delete client confirm modal template -->
    <b-modal ref="delete-client" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-client-title">
          {{ $t('administration.clients.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('administration.clients.delete.description') }} {{ itemToDelete.name }}
      </h5>
      <h5 class="text-center">
        {{ $t('administration.clients.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideConfirmDeleteModal"
                  qid="delete-client-cancel-button"
        >
          {{ $t('administration.clients.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteClient(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-client-submit-button"
        >
          {{ $t('administration.clients.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Edit client modal template -->
    <b-modal ref="edit-client" hide-footer>
      <div class="d-block text-center">
        <h4 qid="update-client-title">
          {{ $t('administration.clients.update.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="edit-c-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editClientFormSubmit" qid="edit-client-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-client-name-label">
              {{ $t('administration.clients.create.name_label') }}
            </label>
            <b-form-input
              qid="edit-client-form-name"
              type="text"
              v-model="clientForm.name"
              required
              :placeholder="$t('administration.clients.create.name_placeholder')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-client-cvr-label">
              {{ $t('administration.clients.create.cvr_label') }}
            </label>
            <b-form-input
              qid="edit-client-form-cvr"
              type="text"
              v-model="clientForm.cvr"
              :placeholder="$t('administration.clients.create.cvr_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-client-street-label">
              {{ $t('administration.clients.create.street_label') }}
            </label>
            <b-form-input
              qid="edit-client-form-street"
              type="text"
              v-model="clientForm.street"
              :placeholder="$t('administration.clients.create.street_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-client-city-label">
              {{ $t('administration.clients.create.city_label') }}
            </label>
            <b-form-input
              qid="edit-client-form-city"
              type="text"
              v-model="clientForm.city"
              :placeholder="$t('administration.clients.create.city_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-client-postcode-label">
              {{ $t('administration.clients.create.postcode_label') }}
            </label>
            <b-form-input
              qid="edit-client-form-postcode"
              type="text"
              v-model="clientForm.postcode"
              :placeholder="$t('administration.clients.create.postcode_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-client-country-label">
              {{ $t('administration.clients.create.country_label') }}
            </label>
            <b-form-input
              qid="edit-client-form-country"
              type="text"
              v-model="clientForm.country"
              :placeholder="$t('administration.clients.create.country_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="create-partition-ref-label">
              {{ $t('administration.partitions.create.reference_label') }}
            </label>
            <b-form-input
              qid="create-partition-form-cvr"
              type="text"
              v-model="clientForm.reference_number"
              :placeholder="$t('administration.partitions.create.reference_label')"
            ></b-form-input>
          </b-form-group>
          <b-form-group>
            <label qid="edit-client-country-label">
              {{ $t('administration.clients.create.trial_label') }}
            </label>
            <datepicker
                class="date-picker"
                qid="filter-p-form-modified-to"
                calendar-class="right"
                @selected="debounceInput"
                @remove="debounceInput"
                v-model="clientForm.trial_ends_at"
                :clear-button="true"
                :placeholder="$t('administration.clients.create.trial_label')"
            ></datepicker>
          </b-form-group>
          <b-form-group>
            <label qid="edit-client-modules-select-label">
              {{ $t('administration.clients.create.modules_label') }}
            </label>
            <multiselect
                v-model="selectedModules"
                :options="modules"
                :multiple="true"
                :taggable="false"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                track-by="code"
                :placeholder="$t('administration.clients.create.modules_placeholder')"
                label="name"
                qid="edit-client-modules-select"
            ></multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditClientModal"
                    qid="edit-client-cancel-button"
          >
            {{ $t('administration.clients.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="edit-client-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('administration.clients.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>

  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js'
import permissionCheck from '@/util/ACL/permissionCheck.js'
import Datepicker from 'vuejs-datepicker';

export default {
  name: 'Clients',
  data: function() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('dashboard.title'),
          to: '/'
        },
        {
          text: this.$t('administration.title'),
          to: '/administration'
        },
        {
          text: this.$t('administration.clients.title'),
          active: true
        }
      ],
      tableItems: [],

      // Pagination
      perPageOptions: [
        { name: '10', value: '10' },
        { name: '20', value: '20' },
        { name: '50', value: '50' },
        { name: '100', value: '100' }
      ],
      perPage: '',
      selectedPerPage: "10",
      currentPage: 1,
      totalRows: 0,

      itemToDelete: {},
      clientForm: {
        slug: '',
        name: '',
        cvr: '',
        street: '',
        city: '',
        postCode: '',
        country: '',
        reference_number: '',
        trial_ends_at: ''
      },
      error: '',
      loading: true,
      buttonDisabled: false,
      selectedModules: [],
      modules: []
    }
  },
  computed: {
    rows() {
      // Use computed value for rows because of dynamic update
      return this.totalRows
    },
    getPerPage() {
      let page = this.currentPage;
      let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
      let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
      let selectedOf = this.totalRows;

      if(selectedTo > selectedOf){
        selectedTo = selectedOf
      }

      return selectedFrom + " - " + selectedTo + " of " + selectedOf
    }
  },
  methods: {
    debounceInput: _.debounce(function() {
      this.loadClients()
    }, 400),
    loadClients(page, perPage) {
      // If page is not defined, set page to default 1
      let pageNumber = page ? page : 1;
      let perPageNumber = perPage ? perPage : this.selectedPerPage;
      let self = this;
      piincHttp.get('clients', { params: {
        page: pageNumber,
        per_page: perPageNumber,
        without_partition: 1
      }}).then(function(response) {
        self.tableItems = response.data.items;
        self.loading = false;
        // Set number of total items
        self.totalRows = response.data.total_count;
      }, function() {

      });
    },
    pageChanged(page) {
      this.loadClients(page)
    },
    perPageChanged(perPage) {
      let self = this;
      // Load content when page changed listener is triggered
      this.loadClients(1, perPage.value)
      self.selectedPerPage = perPage.value
    },
    perPageRemoved() {
      let self = this;
      // Load content when page changed listener is triggered
      self.selectedPerPage = self.perPageOptions[0].value
      this.loadClients(1, self.selectedPerPage)
    },
    isGranted(permission) {
      return permissionCheck(permission)
    },
    confirmDeleteClient(client) {
      let self = this;
      piincHttp.delete('clients/' + client.slug).then(function(response) {
        self.hideConfirmDeleteModal();
        self.loadClients(self.currentPage);
        // Trigger toastr message after modal close
        self.$toastr('success', self.$t('administration.clients.delete.success'))
      }, function() {

      });
    },
    editClientFormSubmit(evt) {
      this.buttonDisabled = true;
      // Keep the reference in a variable
      // to use it inside function called when promise returned
      let self = this;
      evt.preventDefault();

      this.clientForm.modules = [];
      if (this.selectedModules && this.selectedModules.length) {
        for (var i = 0; i < this.selectedModules.length; i++) {
          this.clientForm.modules.push(this.selectedModules[i].id);
        }
      }

      piincHttp.put('clients/' + this.clientForm.slug, this.clientForm).then(function(response) {
        self.hideEditClientModal();
        self.loadClients(self.currentPage);
        self.$toastr('success', self.$t('administration.clients.update.success'))
        self.buttonDisabled = false;
      }, function(error) {
        if (error.status !== 200) {
          self.buttonDisabled = false;
          self.error = error.data.message;
        }
      })
    },
    showEditClientModal(object) {
      let self = this;

      this.clientForm.slug = object.slug
      this.clientForm.name = object.name
      this.clientForm.cvr = object.cvr
      this.clientForm.street = object.street
      this.clientForm.city = object.city
      this.clientForm.postcode = object.postcode
      this.clientForm.country = object.country
      this.clientForm.reference_number = object.reference_number
      this.clientForm.trial_ends_at = object.trial_ends_at

      if (object.activeModules && object.activeModules.length) {
        self.selectedModules = [];
        _.forEach(object.activeModules, function (value, key) {
          _.find(self.modules, function(item) {
            if (item.id === value.id) {
              self.selectedModules.push(item)
            }
          });
        })
      }

      this.$refs['edit-client'].show()
    },
    hideEditClientModal() {
      this.selectedModules = [],
      this.$refs['edit-client'].hide()
    },
    showConfirmDeleteModal(object) {
      this.itemToDelete = object
      this.$refs['delete-client'].show()
    },
    hideConfirmDeleteModal() {
      this.itemToDelete = {};
      this.$refs['delete-client'].hide()
    },
    loadModules() {
      let self = this;
      piincHttp.get('modules').then(function(response) {
        self.modules = response.data.items
      }, function() {});
    }
  },
  components: {
    Datepicker
  },
  created () {
    if (this.$route.params.reload) {
      window.location.reload();
    } else {
      this.loadClients();
      this.loadModules();
    }
  }
}
</script>
